import { Container } from '@/components/ui/template/Container'
import { ButtonLink } from '@/components/ui/Button'
import { SlideIn } from '@/components/ui/transitions/SlideIn'
import { useWindowSize } from '@/hooks/helpers/useWindowSize'
import { testIdFactory } from '@/utils/test-id-factory.ts'

const PepperIncSection = () => {
	const { isMobile } = useWindowSize()

	return (
		<Container className="bg-green-10">
			<Container.Content className="flex flex-col md:flex-row justify-between items-center gap-10 pb-10 overflow-hidden">
				<SlideIn from={isMobile ? 'top' : 'right'} className="md:order-2">
					<img
						src="/images/pepper-inc-tower.png"
						alt="Pepper Inc"
						className="aspect-square object-contain max-w-[220px] md:max-w-[280px]"
						loading="lazy"
					/>
				</SlideIn>
				<SlideIn from={isMobile ? 'bottom' : 'left'} className="flex flex-col gap-10 md:gap-6 md:order-1">
					<div>
						<h1 className="uppercase text-[5rem] text-neutral-100 font-bold text-center md:text-left leading-none">
							PEPPER INC.
						</h1>
					</div>
					<p className="text-neutral-40 text-[1.5rem] leading-[26px]">
						PEPPER Inc. allows you to stake your PEPPER in order to vote on the hottest topics and manage
						the community treasury like a true PEPPER boss!
					</p>
					<ButtonLink
						to="/pepper-inc"
						variant="danger"
						className="md:self-start py-5 px-10 leading-none"
						data-testid={testIdFactory.homeEnterPepperINCButton()}
					>
						Enter PEPPER Inc.
					</ButtonLink>
				</SlideIn>
			</Container.Content>
		</Container>
	)
}

export default PepperIncSection
